//@flow
import * as React from 'react';

import {
  Container
} from 'flux/utils';
import Store from './auth-store';
// import invariant from 'fbjs/lib/invariant';
import LoginPanel from './login-panel'

// import {
//   Redirect
// } from 'react-router-dom'

class LoginPanelContainer extends React.Component < * > {

  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return {
      store: Store.getState(),
    };
  }

  render() {
    // if (this.state && this.state.store.get('isLoggedIn')) {
    //   return <Redirect push to="/" />
    // } else {
    return <LoginPanel />
    // }
  }
}

export default Container.create(LoginPanelContainer);